export const permissions = {
  3: { label: 'Restaurant Manager', value: 3 },
  2: { label: 'Restaurant Owner', value: 2 },
  12: { label: 'Restaurant Operator', value: 12 },
};
